import React, {FC} from "react";
import {Col, DatePicker, Form, Input, Row, Select} from "antd";
import Button from "/react4xp/mixins/ui/button/button";

const ArchiveFilter: FC<any> = (props: any) => {
    const [form] = Form.useForm();

    const clear = () => {
        form.resetFields();
        props.search();
    };

    return (
        <Form form={form} layout="vertical" className="my-3" onFinish={props.search}>
            <Row gutter={15}>
                <Col span={12}>
                    <Form.Item
                        label="Наименование"
                        name="name"
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        label="Дата"
                        name="date"
                    >
                        <DatePicker picker="date" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        label="Пользователь"
                        name="user"
                    >
                        <Select
                            options={props.users.hits.map(x => ({
                                label: x.displayName,
                                value: x.key,
                            }))}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row justify="end" gutter={15}>
                <Col>
                    <Button onClick={clear}>
                        Сбросить
                    </Button>
                </Col>
                <Col>
                    <Button type="primary" color="gold" htmlType="submit">
                        Поиск
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};

export default ArchiveFilter;
